module.exports = __webpack_public_path__ + "media/newstyle/images/img2-footer-257baf97ca287a13b4e6bf7bc6f327b0.svg";